const MATERIALS_GASKETS = [
  // Eco
  {
    url: "https://www.vedinimas.lt/flx-75-new-sandarinimo-gumine-tarpine",
    icon: "https://www.vedinimas.lt/images/uploader/fl/588x588.g/flxs-75-siaura-sandarinimo-gumine-tarpine-3.jpg",
    code: "900000012",
    name: "Sandarinimo guminė tarpinė FLX-75 siaura",
    productGroup: "normal",
    good_id: 46787,
  },
  // Premium
  {
    url: "https://www.vedinimas.lt/flx-75-sandarinimo-gumine-tarpine",
    icon: "https://www.vedinimas.lt/images/uploader/fl/588x588.g/flx-75-sandarinimo-gumine-tarpine-2-1.jpg",
    code: "900000004",
    name: "Sandarinimo guminė tarpinė FLX-75",
    productGroup: "premium",
    good_id: 46782,
  }
];

export default MATERIALS_GASKETS;
